function initCounters(scope = document) {
  const counters = scope.querySelectorAll('.counter');

  function easeOutExpo(t) {
    return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
  }

  function formatNumber(value, decimals) {
    return value.toLocaleString(undefined, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  }

  counters.forEach(counter => {
    if (counter._observerAttached) return;
    counter._observerAttached = true;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          resetCounter(counter);
          return;
        }

        animateCounter(counter);
      });
    }, { threshold: 0.5 });

    observer.observe(counter);
  });

  function animateCounter(counter) {
    if (counter._animating) return;
    counter._animating = true;

    const min = parseFloat(counter.dataset.min) || 0;
    const max = parseFloat(counter.dataset.max) || 0;
    const numberEl = counter.querySelector('.number');
    const duration = 1600;

    const decimals =
      (counter.dataset.max.split('.')[1] || '').length;

    let startTime = null;

    function frame(now) {
      if (!startTime) startTime = now;

      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const eased = easeOutExpo(progress);
      const value = min + (max - min) * eased;

      numberEl.textContent = formatNumber(value, decimals);

      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        counter._animating = false;
      }
    }

    requestAnimationFrame(frame);
  }

  function resetCounter(counter) {
    const min = parseFloat(counter.dataset.min) || 0;
    const decimals =
      (counter.dataset.min.split('.')[1] || '').length;

    counter.querySelector('.number').textContent =
      min.toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });

    counter._animating = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initCounters();
});

document.addEventListener('shopify:section:load', (e) => {
  initCounters(e.target);
});